import { useEffect } from 'react';
import { useApparence } from './apparence';
import { useAuPouce } from './surface';

const ouiNon = (valeur: boolean) => (valeur ? 'oui' : 'non');

/**
 * Pose l'apparence choisie sur la racine de la page (`<html data-ambiance data-ecriture
 * data-relief data-grain>`), où les feuilles de `styles/ambiances/` la lisent.
 *
 * La forme des bulles n'y est plus (chantier habit-du-projet, ticket 03) : chaque projet a la
 * sienne, posée sur le conteneur de sa Carte et de sa Hiérarchie (`data-forme`), et lue par les
 * feuilles de `styles/bulles/`. Celle de Paramètres est la forme d'un projet neuf.
 *
 * Au téléphone (`useAuPouce`), toujours le Carnet, écrit à la main, quel que soit le choix gardé
 * pour l'ordinateur (chantier telephone-habit, décision 3 d'Igor du 2026-10-22 : ni Clair ni
 * Sombre au téléphone pour l'instant). Le grain y est dans le papier de la page
 * (`styles/ambiances/carnet-au-pouce.css`), pas dans celui de l'ordinateur : `data-grain` reste à
 * « non ».
 */
export function ApparenceDeLaPage(): null {
  const auPouce = useAuPouce();
  const { ambiance, ecriture, relief, grain } = useApparence();

  useEffect(() => {
    const racine = document.documentElement;
    if (auPouce) {
      racine.dataset.ambiance = 'carnet';
      racine.dataset.ecriture = 'oui';
      racine.dataset.relief = 'marque';
      racine.dataset.grain = 'non';
      return;
    }
    racine.dataset.ambiance = ambiance;
    racine.dataset.ecriture = ouiNon(ecriture);
    racine.dataset.relief = relief;
    racine.dataset.grain = ouiNon(grain);
  }, [auPouce, ambiance, ecriture, relief, grain]);

  return null;
}
